<template lang="pug">
	.easy-creative--feedback
		Popup(v-if="visible", :popupVisible.sync="visible",:width="440", :height="310")
			.flex-col.space
				.font-big.upper.grey {{$tCaption('Feedback')}}
				span {{$tCaption('Your feedback is important to us. It helps us to resolve problems, have new ideas and improve our product.')}}
				DxTextArea(:height="120", :value.sync="text", stylingMode="filled", :placeholder="$tCaption('Write something here..')", value-change-event="input")
				Loader(v-if="loading", text="", :fullscreen="true")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="visible = false")
				DxButton(:text="$tCaption('Send')", @click="save", type="default", :disabled="loading || !text")
</template>

<script>
	import Popup from 'app-core/Popup.vue';
	import DxTextArea from 'devextreme-vue/text-area';
	import DxButton from 'devextreme-vue/button';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'creative.EasyCreativeFeedback',
		name: 'asy-creative--feedback',
		props: ['info'],
		components: {
			Popup, DxTextArea, DxButton, Loader
		},
		data() {
			return {
				visible: false,
				text: false,
				loading: false
			};
		},
		computed: {
			
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.easyCreativeFeedback = this;
		},
		methods: {
			save() {
				this.loading = true;
				this.$Data.postExternalApi('Feedback/CreateUpdate', {
					Text: this.text,
					Brief: {
						Oid: this.info.briefId
					}
				}).then(r => {
					if (r?.Success !== false ) {
						this.visible = false;
						this.$notifySuccess(this.$tCaption('Thank you for submitting your feedback.'));
					}
				}).finally(() => {
					this.loading = false;
				});
			},
			show() {
				this.text = null;
				this.visible = false;
				setImmediate(() => this.visible = true);
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.easy-creative--feedback {

	}
</style>
